
export default [
  {
    identifier: 'us',
    title: 'Style by state',
    image: require('@/assets/chapters/ch3/infographic_us.jpg'),
    description: 'Who’s wearing what, where? We were curious, too, so looked at how Americans will be spending their luxury fashion dollars next season, according to Trunkshow transaction data. Here’s what we found.'
  },
  {
    identifier: 'nyc',
    title: 'Who New Yorkers are Wearing This Fall',
    image: require('@/assets/chapters/ch3/infographic_nyc.jpg'),
    description: 'Moda Operandi was founded in New York City. As we’re based in one of the world’s biggest fashion capitals, we wanted to dig deeper to see how women across the city would be dressing this fall, and which designers they’re gravitating toward the most. Here, we determined who New Yorkers will be wearing this fall, based on Trunkshow transaction data.'
  }
]
